<div id="timer">
    <div class="icon"></div>
    <span class="time"></span>
</div>